import React, { useEffect, useState } from 'react';
import {
  Box, TextField, Container, Grid, Card, CardContent, Button, FormControl,
  InputLabel, MenuItem, Select, Checkbox, FormControlLabel, Snackbar,
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography
} from '@mui/material';
import { Helmet } from 'react-helmet-async';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DateTimePicker from '@mui/lab/DateTimePicker';
import axios from 'axios';
import { format } from 'date-fns';
import { useSnackbar } from 'src/components/snackbar/useSnackbar';
import { useNavigate } from 'react-router';
import { authenticationService } from "src/services";
import { post } from 'src/services/httpClient.service';

interface FormValues {
  id?: number;
  jobName: string;
  moduleName: string;
  taskType: 'GLOBAL' | 'CHANNEL' | 'SUBSCRIBER' | 'FORENSIC';
  scheduleType: 'cron' | 'interval' | 'datetime';
  cronExpression: string;
  intervalSeconds: number;
  isActive: boolean;
  maxRetries: number;
  retryCount: number;
  runAt: Date | null;
  payload: string;
  createdAt?: string;
  updatedAt?: string;
}

const APIURL = process.env.REACT_APP_BASE_API_URL;

const Add_Schedule = ({ handleClose, payload, taskType,globalfp }) => {

  const {vendorId, franchiseId} = authenticationService.getVendorFranchiseIds()

  console.log('globalfp',globalfp)
  
  const navigate = useNavigate()
  const { showSnackbar } = useSnackbar();
  // Get the first item if globalfp is an array, or use empty object
  const globalFpData = Array.isArray(globalfp) && globalfp.length > 0 
    ? globalfp[0] 
    : {};

  // Initialize form values
  const [formValues, setFormValues] = useState<FormValues>({
    jobName: globalFpData.jobName || '',
    moduleName: globalFpData.moduleName || 'FINGERPRINT',
    //taskType: taskType || globalFpData.taskType || 'GLOBAL',
    taskType: taskType ? taskType : 'GLOBAL',
    scheduleType: globalFpData.scheduleType || 'cron',
    cronExpression: globalFpData.cronExpression || '',
    intervalSeconds: globalFpData.intervalSeconds || 0,
    isActive: globalFpData.isActive !== undefined ? globalFpData.isActive : true,
    maxRetries: globalFpData.maxRetries || 3,
    retryCount: globalFpData.retryCount || 0,
    runAt: globalFpData.runAt ? new Date(globalFpData.runAt) : null,
    payload: payload ? JSON.stringify(payload) : ''
  });

  // Update form when globalfp changes
  useEffect(() => {
    const newData = Array.isArray(globalfp) && globalfp.length > 0 
      ? globalfp[0] 
      : {};
      
    setFormValues(prev => ({
      ...prev,
      jobName: newData.jobName || prev.jobName,
      moduleName: newData.moduleName || prev.moduleName,
      //taskType: newData.taskType || prev.taskType,
      taskType: taskType || prev.taskType,
      scheduleType: newData.scheduleType || prev.scheduleType,
      cronExpression: newData.cronExpression || prev.cronExpression,
      intervalSeconds: newData.intervalSeconds || prev.intervalSeconds,
      isActive: newData.isActive !== undefined ? newData.isActive : prev.isActive,
      maxRetries: newData.maxRetries || prev.maxRetries,
      retryCount: newData.retryCount || prev.retryCount,
      runAt: newData.runAt ? new Date(newData.runAt) : prev.runAt,
      // Keep existing payload
      payload: prev.payload
    }));
  }, [globalfp, taskType]);


  const [open, setOpen] = useState(false);

  // Determine which task types to show based on props
  /* const getTaskTypeOptions = () => {
    switch (taskType) {
      case 'GLOBAL':
        return [{ value: 'GLOBAL', label: 'GLOBAL' }];
      case 'CHANNEL':
        return [{ value: 'CHANNEL', label: 'CHANNEL' }];
      case 'SUBSCRIBER':
        return [{ value: 'SUBSCRIBER', label: 'SUBSCRIBER' }];
      default:
        return [
          { value: 'GLOBAL', label: 'GLOBAL' },
          { value: 'CHANNEL', label: 'CHANNEL' },
          { value: 'SUBSCRIBER', label: 'SUBSCRIBER' }
        ];
    }
  }; */
const getTaskTypeOptions = () => {
  switch (taskType) {
    case 'GLOBAL':
      return [{ value: 'GLOBAL', label: 'GLOBAL' }];

    case 'CHANNEL':
      return [{ value: 'CHANNEL', label: 'CHANNEL' }];

    case 'SUBSCRIBER':
      return [{ value: 'SUBSCRIBER', label: 'SUBSCRIBER' }];

    case 'FORENSIC':
      return [{ value: 'FORENSIC', label: 'FORENSIC' }];

    default:
      return [
        { value: 'GLOBAL', label: 'GLOBAL' },
        { value: 'CHANNEL', label: 'CHANNEL' },
        { value: 'SUBSCRIBER', label: 'SUBSCRIBER' },
        { value: 'FORENSIC', label: 'FORENSIC' }
      ];
  }
};
  const taskTypeOptions = getTaskTypeOptions();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { id, value, type } = e.target as HTMLInputElement;

    setFormValues(prev => ({
      ...prev,
      [id]: type === 'number' ? Number(value) : value
    }));
  };

  const handleSubmit = async () => {
    try {
      const now = new Date().toISOString();

          // Get the ID from globalfp if it exists (handling both array and object cases)
    const globalFpId = Array.isArray(globalfp) && globalfp.length > 0 
      ? globalfp[0]?.id 
      : globalfp?.id;

      const requestPayload = {

        // Include the ID if it exists (for updates)
      ...(globalFpId && { id: globalFpId }),
        jobName: formValues.jobName || `Job-${new Date().getTime()}`,
        moduleName: formValues.moduleName,
        taskType: formValues.taskType,
        scheduleType: formValues.scheduleType,
        cronExpression: formValues.scheduleType === 'cron' ? formValues.cronExpression : null,
        intervalSeconds: formValues.scheduleType === 'interval' ? formValues.intervalSeconds : 0,
        isActive: formValues.isActive,
        maxRetries: formValues.maxRetries,
        retryCount: formValues.retryCount,
        runAt: formValues.scheduleType === 'datetime' && formValues.runAt
          ? format(formValues.runAt, "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'")
          : null,
        payload: formValues.payload,
        createdAt: now,
        updatedAt: now,
        vendorId: vendorId,
        franchiseId: franchiseId,
      };

      const response = await post(
        `${APIURL}/api/scheduled-jobs`,
        requestPayload/* ,
        {
          headers: {
            'Content-Type': 'application/json'
          },
        } */
      );

        showSnackbar('Scheduled job created successfully', 'success');
  setOpen(true);
  handleClose();
  navigate('/Schedules/schedules');
      
    } catch (error) {
      showSnackbar(error instanceof Error ? error.message : 'An error occurred', 'error');
      console.error('Error:', error);
    }
  };

  // Parse the payload for display in the table
  const parsedPayload = payload ? JSON.parse(JSON.stringify(payload)) : {};

  return (
    <>
      <Helmet>
        <title>Job Scheduler</title>
      </Helmet>
      <Container maxWidth="lg">
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Card sx={{ boxShadow: 3 }}>
              <CardContent>
                <Grid container spacing={3}>
                  {/*  <Grid item xs={12} sm={6}>
                    <TextField
                      id="jobName"
                      label="Job Name"
                      fullWidth
                      value={formValues.jobName}
                      onChange={handleChange}
                      placeholder="Leave empty for auto-generated name"
                    />
                  </Grid> */}

                  <Grid item xs={12} sm={6}>
                    <TextField
                      id="moduleName"
                      label="Module Name"
                      fullWidth
                      value={formValues.moduleName}
                    /* onChange={handleChange} */
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <FormControl fullWidth>
                      <InputLabel>Task Type</InputLabel>
                      <Select
                        id="taskType"
                        value={formValues.taskType}
                        onChange={(e) => setFormValues({
                          ...formValues,
                          taskType: e.target.value as 'GLOBAL' | 'CHANNEL' | 'SUBSCRIBER' | 'FORENSIC'
                        })}
                        disabled={!!taskType} // Disable if taskType is provided in props
                      >
                        {taskTypeOptions.map((option) => (
                          <MenuItem key={option.value} value={option.value}>
                            {option.label}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <TextField
                      id="retryCount"
                      label="Initial Retry Count"
                      fullWidth
                      value={formValues.retryCount}
                      onChange={handleChange}
                      inputProps={{ min: 0 }}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <FormControl fullWidth>
                      <InputLabel>Schedule Type</InputLabel>
                      <Select
                        id="scheduleType"
                        value={formValues.scheduleType}
                        onChange={(e) => setFormValues({
                          ...formValues,
                          scheduleType: e.target.value as 'cron' | 'interval' | 'datetime'
                        })}
                      >
                        <MenuItem value="cron">Cron</MenuItem>
                        <MenuItem value="interval">Interval</MenuItem>
                        <MenuItem value="datetime">Datetime</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>

                  {formValues.scheduleType === 'cron' && (
                    <Grid item xs={12}>
                      <FormControl fullWidth>
                        <InputLabel>Cron Expression</InputLabel>
                        <Select
                          id="cronExpression"
                          value={formValues.cronExpression}
                          onChange={(e) => setFormValues({ ...formValues, cronExpression: e.target.value })}
                          label="Cron Expression"
                          required
                        >
                          {[
                           /*  { label: "Every 1 minute", value: "0 0/1 * * * ?" },
                            { label: "Every 5 minutes", value: "0 0/5 * * * ?" }, */
                            { label: "Every 10 minutes", value: "0 0/10 * * * ?" },
                            { label: "Every 30 minutes", value: "0 0/30 * * * ?" },
                            { label: "Every 1 hour", value: "0 0 0/1 * * ?" },
                            { label: "Every day", value: "0 0 0 * * ?" },
                            { label: "Specific day in a week (Mon)", value: "0 0 0 ? * MON" },
                            { label: "Weekends", value: "0 0 0 ? * SAT,SUN" },
                            { label: "Every 15 days", value: "0 0 0 1,16 * ?" },
                            { label: "Every 1 month", value: "0 0 0 1 * ?" },
                            { label: "Every 3 months", value: "0 0 0 1 1,4,7,10 ?" },
                            { label: "Every 6 months", value: "0 0 0 1 1,7 ?" },
                            { label: "Every 1 year", value: "0 0 0 1 1 ?" }
                          ].map((option) => (
                            <MenuItem key={option.value} value={option.value}>
                              {option.label}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                  )}

                  {formValues.scheduleType === 'interval' && (
                    <Grid item xs={12}>
                      <TextField
                        id="intervalSeconds"
                        label="Interval Seconds"
                        fullWidth
                        value={formValues.intervalSeconds}
                        onChange={handleChange}
                        inputProps={{ min: 0 }}
                      />
                    </Grid>
                  )}

                  {formValues.scheduleType === 'datetime' && (
                    <Grid item xs={12}>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DateTimePicker
                          label="Run At"
                          value={formValues.runAt}
                          onChange={(date) => setFormValues({ ...formValues, runAt: date })}
                          renderInput={(params) => <TextField {...params} fullWidth />}
                        />
                      </LocalizationProvider>
                    </Grid>
                  )}

                  {/* Payload Display in Table */}
                  <Grid item xs={12}>
                    <Typography variant="h6" gutterBottom>
                      Fingerprint Settings
                    </Typography>
                    <TableContainer component={Paper} sx={{ maxHeight: 300, overflow: 'auto' }}>
                      <Table size="small" stickyHeader>
                        <TableHead>
                          <TableRow>
                            <TableCell>Setting</TableCell>
                            <TableCell>Value</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {Object.entries(parsedPayload).map(([key, value]) => (
                            <TableRow key={key}>
                              <TableCell sx={{ fontWeight: 'bold' }}>{key}</TableCell>
                              <TableCell>
                                {typeof value === 'boolean' ?
                                  (value ? 'Yes' : 'No') :
                                  String(value)}
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={formValues.isActive}
                          onChange={(e) => setFormValues({
                            ...formValues,
                            isActive: e.target.checked
                          })}
                        />
                      }
                      label="Is Active"
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <TextField
                      id="maxRetries"
                      label="Max Retries"
                      fullWidth
                      value={formValues.maxRetries}
                      onChange={handleChange}
                      inputProps={{ min: 0 }}
                    />
                  </Grid>
                </Grid>

                <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 4 }}>
                  <Button onClick={handleClose} variant="outlined" sx={{ mr: 2 }}>Cancel</Button>
                  <Button onClick={handleSubmit} variant="contained">Submit</Button>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container>

      <Snackbar
        open={open}
        autoHideDuration={5000}
        onClose={() => setOpen(false)}
        message="Job scheduled successfully"
      />
    </>
  );
};

export default Add_Schedule;